import { render, staticRenderFns } from "./Parametre.vue?vue&type=template&id=189ff9b5&"
import script from "./Parametre.vue?vue&type=script&lang=js&"
export * from "./Parametre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports